module.exports = __webpack_public_path__ + "static/img/main_banner.d169e511.png";